import { PAGES } from '@/router/routeInitial.state';

export const getPageTitle = (pathname: string): string => {
  const page = Object.values(PAGES).find(({ path }) => {
    const pagePath = path
      .replace(/:([^/]+)(?!\?)/g, '[^/]+')
      .replace(/\/?:([^/]+)\?/g, '(?:/[^/]+)?');
    const regex = new RegExp(`^${pagePath.replace(/\//g, '\\/')}$`);
    return regex.test(pathname);
  });

  return page?.name || '';
};
